import React, {useState, useEffect} from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import * as apiAdmin from "../../../../api/apiAdmin"
import * as apiCompany from "../../../../api/apiCompany"
import * as apiMenu from "../../../../api/apiMenu"
import { RoleItem, RoleSelect, ManagerSelect, CompanySelect, DepartmentSelect } from '../../item/PermissionItems';
import { ContentBox } from '../../Content/ContentBox';

export function AdminPermissionList ({id}) {

  const[managerList, setManagerList] = useState([]);
  const[managerId, setManagerId] = useState("");
  const[companyList, setCompanyList] = useState([]);
  const[companyId, setCompanyId] = useState("");
  const[departmentList, setDepartmentList] = useState([]);
  const[departmentId, setDepartmentId] = useState("");

  const [menuItems, setMenuItems] = useState([]) ;
  const[roleList, setRoleList] = useState([]);
  const[pageList, setPageList] = useState([]);
  const[PermissionList, setPermissionList] = useState([]);
  const[token] = useState(Auth.getToken())
  const[roleId, setRoleId] = useState("");
  function getMenuList(){
    //console.log("getMenus")
    //console.log("token");
    //console.log(token);
    apiMenu.getRealMenu({
      success: (obj, menuItems) =>{
        console.log("AAAA")
          //console.log(menuItems)
          setMenuItems(menuItems);
      },
      failure: (err)=>{

      }
    })
  }

  function init(){
    setCompanyList([])
    setCompanyId("")
    setDepartmentList([])
    setDepartmentId("")
    setRoleList([])
    setRoleId("")
  }

  function getManagerList(){
    apiAdmin.getClientAdminList({
      success: (obj)=>{
        if(obj.status){
          //console.log(obj)
          setManagerList(obj.list)
          setManagerId("system")
          //console.log("page : "+ page)
        }else{
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '發生錯誤, 請洽詢技術人員',
          }).then(function() {
          })
        }
      },
      failure:(err)=>{
        
      }
    })
  }


  function getCompanyList(){
    init()
    console.log("getCompanyList")
    console.log(managerId)
    apiCompany.getCompanyList({
      applyId: managerId, 
      success:(obj)=>{
        console.log(obj)
        if(obj.status){
          setCompanyList(obj.list)
          if(obj.list.length > 0){
            console.log("setCompanyId")
            console.log(obj.list[0].companyId)
            setCompanyId(obj.list[0].companyId)
          }
          //console.log("page : "+ page)
        }else{
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '發生錯誤, 請洽詢技術人員',
          }).then(function() {
          })
        }
      },
      failure: (err)=>{

      }
    })
  }

  function getDepartmentList(){
    console.log("getDepartmentList")
    console.log(companyId)
    apiCompany.api_getDepartmentList({companyId, 
      success:(obj)=>{
        console.log(obj)
        if(obj.status){
          setDepartmentList(obj.list)
          if(obj.list.length > 0){
            setDepartmentId(obj.list[0].departmentId)
          }
          //console.log("page : "+ page)
        }else{
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: '發生錯誤, 請洽詢技術人員',
          }).then(function() {
          })
        }
      },
      failure:(err)=>{

      }
    })
  }

  function getRoleList(){
    console.log(departmentId)
    apiCompany.api_getRoleList({departmentId, 
      success: (obj)=>{
        console.log(obj)
        setRoleList(obj.list);
        if(obj.list.length > 0){
          setRoleId(obj.list[0].roleId);
        }
      },
      failure:()=>{}
    });
  }
  function getPageList(){
    apiMenu.getPageRealList({
      success: (obj)=>{
        setPageList(obj.pages)
      },
      failure: (err)=>{

      }
    })
  }

  function getPermission(){
    //console.log("getPermission"+roleId);
    apiAdmin.getPermission({roleId, 
      success: (obj)=>{
        // console.log(obj);
        setPermissionList(obj.list);
      },
      failure: (err)=>{}
    })
  }


  useEffect(()=>{
    getManagerList();
    getMenuList();
    getPageList();
  },[]);


  useEffect(()=>{
    if(managerId !== ""){
      console.log("getCompanyList" + managerId)
      getCompanyList();
    }
  },[managerId])

  useEffect(()=>{
    if(companyId !== ""){
      getDepartmentList();
    }
  },[companyId])


  useEffect(()=>{
    if(departmentId !== ""){
      getRoleList();
    }
  },[departmentId])

  useEffect(()=>{
    getPermission();
  },[roleId]);



  function MenuTable(){
    if(menuItems.length >0 && pageList.length >0){
      //console.log(menuItems)
      return(
        <ol>
          {
            menuItems.map((header, headerIndex) =>(
              <MenuItemHeaderBox key={"header"+header.menuId}  header={header} />
            ))
          }
        </ol>
      )
    }else{
      return(<></>)
    }
  }

  function MenuItemHeaderBox({header}){
    //console.log(header)
    return(
      < >
        <li >{header.menuName}</li>
          <ol>
            {
              header.items.map((title, titleIndex)=>(
                <MenuItemTitleBox key={"title"+title.menuId} title={title} />
              ))
            }
          </ol>
      </>
    )
  }

  function MenuItemTitleBox({title}){
    return(
      <>
        <li key={"title"+title.menuId}>{title.menuName}</li>
        <ol>
          {
            title.items.map((item, itemIndex)=>(
              <MenuItemBox key={"item"+item.menuId} item={item} />
            ))
          }
        </ol>
      </>)
  }

  function MenuItemBox({item}){
    return(
      <li key={"it"+item.menuId}>{item.menuName}
      {
        <RoleAdmin key={item.menuId} item={item} pageList={pageList} />
      }
      </li>
    )
  }

  function RoleAdmin({item, pageList}){
    //console.log(pageList)
    var html = "";
    var filterEmpty = pageList.filter(function(pageItem, index, array){
      return pageItem.menuId === item.menuId;
    });
    if(filterEmpty.length > 0){
      html = <RoleItems  items={filterEmpty} />
    }
    return(
      <>
      {html}
      </>
    )
  }

  function RoleItems({items}){

    return(
      items.map((item, index)=>(
        <div key={"it"+index} className="row">
        <div className="col-md-11">
          <div className="well">
            <RoleItem key={"item"+item.menuId} item={item} roleId={roleId} PermissionList={PermissionList} />
          </div>              
        </div>
        </div>
      ))
    )
  }


  if(roleList === undefined){
    return (<></>)
  }else{

    var toolsContent = <>
    <ManagerSelect managerList={managerList} setManagerId={setManagerId} />
    <CompanySelect companyList={companyList} setCompanyId={setCompanyId} />
    <DepartmentSelect departmentList={departmentList} setDepartmentId={setDepartmentId} />
    <RoleSelect roleList={roleList} setRoleId={setRoleId} />
    </>
    return (    
      <>
      <ContentBox hasTitle={false}  content={toolsContent}  hasDrawer={true} />
      <ContentBox title={"角色權限設定"}  content={<MenuTable />}  hasDrawer={true} />          
      </>
    )
  }
}